import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MdArrowBack } from 'react-icons/md';
import { LanguageSelector, useLanguage } from '../i18n';
import { API_BASE, withSystem, localizedField, SYSTEM_SLUG } from './publicApi';

// Moved off the homepage (PublicBooking.js) so the homepage itself stays a
// short, two-screen scroll. This page carries the same "About Us" content
// that used to live in a <section id="about"> there — now its own route so
// it doesn't add to the homepage's length, but is still one click away from
// the nav bar / footer.
export default function AboutPage() {
    const { language, t } = useLanguage();
    const [homepage, setHomepage] = useState(null);
    const ownSystem = !!SYSTEM_SLUG;   // organizations show only the text they wrote

    useEffect(() => {
        axios.get(`${API_BASE}/homepage`, { params: withSystem() }).then(response => {
            setHomepage(response.data);
        }).catch(() => { });
    }, []);

    return (
        <div style={{ minHeight: '100vh', background: '#fff', fontFamily: "'Inter',-apple-system,sans-serif" }}>
            <nav style={{
                background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 5%', height: 68,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                position: 'sticky', top: 0, zIndex: 200, boxShadow: '0 1px 8px rgba(0,0,0,0.06)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <img src={homepage?.logo_url || '/logo512.png'} alt={`${homepage?.system_name || 'MITI FMS'} ${t('about.logoAlt')}`} style={{ width: 38, height: 38, borderRadius: 9, objectFit: 'cover' }} />
                    <div>
                        <div style={{ fontWeight: 800, fontSize: 17, color: '#0f172a', lineHeight: 1 }}>{homepage?.system_name || 'MITI FMS'}</div>
                        {!ownSystem && <div style={{ fontSize: 10, color: '#94a3b8', letterSpacing: '0.5px' }}>{t('about.facilityManagementLabel')}</div>}
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                    <LanguageSelector style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 999, padding: '4px 8px' }} />
                    <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#2563eb', fontWeight: 600, textDecoration: 'none', border: '1.5px solid #2563eb', padding: '7px 16px', borderRadius: 8 }}>
                        <MdArrowBack size={15} /> {t('about.backToHome')}
                    </a>
                </div>
            </nav>

            <section style={{ padding: '64px 5% 80px', background: '#fff' }}>
                <div style={{ maxWidth: 1100, margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: 56 }}>
                        {!ownSystem && <span style={{ fontSize: 12, fontWeight: 700, color: '#2563eb', textTransform: 'uppercase', letterSpacing: '1.5px' }}>{t('about.eyebrow')}</span>}
                        {!ownSystem && <h1 style={{ fontWeight: 800, fontSize: 36, color: '#0f172a', marginTop: 8, marginBottom: 16 }}>{t('about.heroTitle')}</h1>}
                        {localizedField(homepage, 'about', language) && <p style={{ color: '#64748b', maxWidth: 560, margin: '0 auto', fontSize: 16, lineHeight: 1.7 }}>
                            {localizedField(homepage, 'about', language)}
                        </p>}
                    </div>

                    {!ownSystem && <div className="row g-4">
                        {[
                            { icon: '🏗️', title: t('about.feature1Title'), desc: t('about.feature1Desc') },
                            { icon: '🔒', title: t('about.feature2Title'), desc: t('about.feature2Desc') },
                            { icon: '♻️', title: t('about.feature3Title'), desc: t('about.feature3Desc') },
                            { icon: '🤝', title: t('about.feature4Title'), desc: t('about.feature4Desc') },
                        ].map(item => (
                            <div key={item.title} className="col-lg-3 col-md-6">
                                <div style={{ background: '#f8fafc', borderRadius: 14, padding: 28, height: '100%', border: '1px solid #e2e8f0' }}>
                                    <div style={{ fontSize: 36, marginBottom: 16 }}>{item.icon}</div>
                                    <h5 style={{ fontWeight: 700, color: '#0f172a', marginBottom: 10 }}>{item.title}</h5>
                                    <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, margin: 0 }}>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>}
                </div>
            </section>

            <footer style={{ background: '#0f172a', color: '#94a3b8', padding: '24px 5%', textAlign: 'center', fontSize: 13 }}>
                © {new Date().getFullYear()} {homepage?.system_name || 'MITI FMS'}. {t('about.footerRights')}
            </footer>
        </div>
    );
}
